exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mediaEditor {\n  padding-left: 20px; }\n\n.mediaHeader {\n  font-size: 120%;\n  font-weight: bold; }\n\n.mediaLabel {\n  font-weight: bold; }\n\n.caption {\n  margin-left: 30px;\n  width: 90%; }\n\n.captionHeader {\n  font-weight: bold; }\n", ""]);

// exports
